import { createSignal, onCleanup } from 'solid-js'

export type Screen = 'loss' | 'plans'

const PLANS_PATH = '/plans'

function screenAt(pathname: string): Screen {
  return pathname.replace(/\/+$/, '') === PLANS_PATH ? 'plans' : 'loss'
}

/**
 * The screen by pathname: root is the loss screen, `/plans` the plan picker.
 * The Android back button is not intercepted; popping back from `/plans`
 * just follows the history.
 */
export function createScreen() {
  const [screen, setScreen] = createSignal(screenAt(window.location.pathname))

  const onPopState = () => setScreen(screenAt(window.location.pathname))
  window.addEventListener('popstate', onPopState)
  onCleanup(() => window.removeEventListener('popstate', onPopState))

  function openPlanPicker() {
    // Keep the launch query (platform, language, …) on the pushed entry.
    const { search, hash } = window.location
    window.history.pushState(null, '', `${PLANS_PATH}${search}${hash}`)
    setScreen('plans')
  }

  return { screen, openPlanPicker }
}
